<template>
  <div class="footer brand-dark" :style="[toggleFooterPos? { position:'fixed' } : { }]">
    <div class="normal" style="margin:10px">&copy;2026 Nira by <a class="nolink" href="https://bshan.dev" target="_blank">Bhuvan</a></div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    toggleFooterPos: Boolean
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.normal{
    font-family: 'Outfit', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: whitesmoke;
}

.footer {
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}

.nolink{
  text-decoration: none;
  color: whitesmoke;
}

.dimen{
  height:40px; 
  width:100%
}

</style>
